export default {
    API: "https://akitatek.fr",
    Carousel: "https://akitatek.fr/uploads/img/carrousel/",
    Photo: "https://akitatek.fr/uploads/images/annuaire/",
    PhotoBase: "https://akitatek.fr/images/",

}
